import React, { useEffect, useState } from 'react';
import { CallButton, WhatsAppButton } from './ContactButtons';
export function Header() {
  const [compact, setCompact] = useState(false);
  useEffect(() => {
    const onScroll = () => setCompact(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-ink/70 backdrop-blur-xl transition-[padding,background-color] duration-300 ease-smooth ${compact ? 'py-2 bg-ink/85' : 'py-4'}`} data-id="element-69" data-mp="2rl46lnluobw8">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-5 lg:flex-row lg:justify-between lg:gap-8" data-id="element-70" data-mp="31cqo21os777f">
        <a href="#inicio" className={`font-serif leading-tight text-white transition-[font-size] duration-300 ease-smooth ${compact ? 'text-lg lg:text-xl' : 'text-xl lg:text-2xl'}`} data-id="element-71" data-mp="36cwddb7kwhmc">
          Conjuros y Amarres <span className="text-gold-light" data-id="element-72" data-mp="2wlm7hauwjyib">Para El Amor</span>
        </a>

        <div className="flex w-full flex-wrap items-center justify-center gap-3 sm:w-auto lg:w-auto" data-id="element-73" data-mp="2rli2agzg2q7e">
          <span className="inline-flex animate-heartbeat" data-id="element-74" data-mp="2mlvexepwjtkv">
            <CallButton size="sm" label="Llamar" data-id="element-75" data-mp="2mohtvzf4hbd4" />
          </span>
          <span className="inline-flex animate-heartbeat [animation-delay:1.1s]" data-id="element-76" data-mp="2hp4zmtlx920i">
            <WhatsAppButton size="sm" label="WhatsApp" data-id="element-77" data-mp="3faat5z17m7v5" />
          </span>
        </div>
      </div>
    </header>;
}